module.exports = __webpack_public_path__ + "img/pr-2.9389d630.png";